import { render, staticRenderFns } from "./identify.vue?vue&type=template&id=01ff182b&"
import script from "./identify.vue?vue&type=script&lang=js&"
export * from "./identify.vue?vue&type=script&lang=js&"
import style0 from "./identify.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports